import ExitGuard from "@/components/ExitGuard";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Show } from "@clerk/react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { I18nProvider } from "@/i18n";
import Nav from "@/components/Nav";
import Landing from "@/pages/Landing";
import Dashboard from "@/pages/Dashboard";
import ModulePage from "@/pages/ModulePage";
import ChatPage from "@/pages/ChatPage";
import Parents from "@/pages/Parents";
import { SignInPage, SignUpPage } from "@/pages/AuthPages";
import SharedApp from "@/pages/SharedApp";
import PaymentResult from "@/pages/PaymentResult";

function Protected({ children }) {
  return (
    <>
      <Show when="signed-in">{children}</Show>
      <Show when="signed-out">
        <Navigate to="/sign-in" replace />
      </Show>
    </>
  );
}

function Shell() {
  return (
    <>
      <Nav />
      <main>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/parents" element={<Parents />} />
          <Route path="/module/:moduleId" element={<ModulePage />} />
          <Route path="/mi-app/:shareId" element={<SharedApp />} />
          <Route path="/payment/success" element={<PaymentResult />} />
          <Route path="/payment/cancel" element={<PaymentResult cancelled />} />
          <Route
            path="/dashboard"
            element={
              <Protected>
                <Dashboard />
              </Protected>
            }
          />
          <Route
            path="/chat/:mascot"
            element={
              <Protected>
                <ChatPage />
              </Protected>
            }
          />
          <Route path="/sign-in/*" element={<SignInPage />} />
          <Route path="/sign-up/*" element={<SignUpPage />} />
        </Routes>
      </main>
      <ExitGuard />
      <Toaster richColors position="top-center" />
    </>
  );
}

function App() {
  return (
    <div className="App font-nunito">
      <BrowserRouter>
        <ClerkAuthProvider>
          <I18nProvider>
            <Shell />
          </I18nProvider>
        </ClerkAuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
